import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidemenu2',
  templateUrl: './sidemenu2.component.html',
  styleUrls: ['./sidemenu2.component.css']
})
export class Sidemenu2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
